import { Formik, Field, FormikHelpers } from "formik";
import * as yup from "yup";
import { ButtonPageLayout } from "../common/ButtonPageLayout";
import { Input } from "../common/Input";
import styles from "./SignUpForm.module.scss";
import { useMutation } from "@apollo/client";
import { ADD_ADMIN } from "../../apollo/queries";
import { AddAdmin } from "../../apollo/types/AddAdmin";

interface AddAdminValues {
  name: string;
  surname: string;
  email: string;
}

const initialeFormValues = {
  name: "",
  surname: "",
  email: "",
};

const validationSchema = yup.object().shape({
  name: yup
    .string()
    .matches(/^[aA-zZ\s]+$/)
    .required(),
  surname: yup
    .string()
    .matches(/^[aA-zZ\s]+$/)
    .required(),
  email: yup.string().email().required(),
});

export const SignUpForm = () => {
  const [addAdmin, { data }] = useMutation<AddAdmin>(ADD_ADMIN);

  const createAdmin = (name: string, surname: string, email: string) => {
    const fullName = `${name} ${surname}`;
    addAdmin({
      variables: {
        user: {
          emailAddress: email,
          name: fullName,
        },
      },
    });
  };

  return (
    <Formik
      validationSchema={validationSchema}
      initialValues={initialeFormValues}
      onSubmit={(
        values: AddAdminValues,
        { resetForm }: FormikHelpers<AddAdminValues>
      ) => {
        const { name, surname, email } = values;
        createAdmin(name, surname, email);
        resetForm();
      }}
    >
      {({ values, errors, touched, handleChange, handleSubmit }) => (
        <form className={styles.formContainer} onSubmit={handleSubmit}>
          <div className={styles.nameContainer}>
            <Field
              name='name'
              as={Input}
              type='text'
              placeholder='Naam'
              onChange={handleChange}
              value={values.name}
            />
          </div>
          <div className={styles.surnameContainer}>
            <Field
              name='surname'
              as={Input}
              type='text'
              placeholder='Achternaam'
              onChange={handleChange}
              value={values.surname}
            />
          </div>
          <div className={styles.emailContainer}>
            <Field
              name='email'
              as={Input}
              type='text'
              placeholder='E-mail'
              onChange={handleChange}
              value={values.email}
            />
          </div>
          <ButtonPageLayout type='submit'>Meld mij aan!</ButtonPageLayout>
        </form>
      )}
    </Formik>
  );
};
